/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DGA Control API
 * Sistema de monitoreo de extracción de aguas según Resolución 1238 de la DGA (Dirección General de Aguas).
 *
 * ## Protocol-level errors
 *
 * Answered to a request that is no operation of this spec, so no operation declares them. Their `type` is in `ProblemTypeEnum`.
 *
 * - `405` `/problems/method-not-allowed`: the HTTP verb is not supported on that path.
 * - `404` `/problems/not-found`: the URL matched no route at all. Distinct from an endpoint own 404, which means the route exists and the record does not.
 * OpenAPI spec version: 2.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  BillingV1QuoteCatchmentWorksCreatePathParameters,
  BillingV1QuoteCatchmentWorksDestroyPathParameters,
  BillingV1QuoteCatchmentWorksListParams,
  BillingV1QuoteCatchmentWorksListPathParameters,
  BillingV1QuoteCatchmentWorksPartialUpdatePathParameters,
  BillingV1QuoteCatchmentWorksRetrievePathParameters,
  CursorPaginatedQuoteCatchmentWorkResponseV1,
  PatchedQuoteCatchmentWorkUpdateRequestV1Request,
  QuoteCatchmentWorkCreateRequestV1Request,
  QuoteCatchmentWorkResponseV1
} from '../types';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';



interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value
        .filter(
          (item) =>
            item != null &&
            (typeof item === 'string' ||
              typeof item === 'number' ||
              typeof item === 'boolean' ||
              (item instanceof Date && !Number.isNaN(item.getTime()))),
        )
        .map((item) =>
          item instanceof Date ? item.toISOString() : item,
        ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (value instanceof Date && !Number.isNaN(value.getTime())) {
      // useDates produces Date query params; serialize to ISO so they reach
      // the wire instead of being dropped by the primitive check below. See #3856.
      filteredParams[key] = value.toISOString();
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class BillingQuoteCatchmentWorkService {
  private readonly http = inject(HttpClient);
/**
 * Admin-only. Ordered by creation (id ASC).
 * @summary List the draft catchment works of a quote.
 */
 billingV1QuoteCatchmentWorksList<TData = CursorPaginatedQuoteCatchmentWorkResponseV1>(pathParams: BillingV1QuoteCatchmentWorksListPathParameters,
    params?: BillingV1QuoteCatchmentWorksListParams, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuoteCatchmentWorksList<TData = CursorPaginatedQuoteCatchmentWorkResponseV1>(pathParams: BillingV1QuoteCatchmentWorksListPathParameters,
    params?: BillingV1QuoteCatchmentWorksListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuoteCatchmentWorksList<TData = CursorPaginatedQuoteCatchmentWorkResponseV1>(pathParams: BillingV1QuoteCatchmentWorksListPathParameters,
    params?: BillingV1QuoteCatchmentWorksListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuoteCatchmentWorksList<TData = CursorPaginatedQuoteCatchmentWorkResponseV1>(
    { identity }: BillingV1QuoteCatchmentWorksListPathParameters,
    params?: BillingV1QuoteCatchmentWorksListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/quotes/${identity}/catchment_works/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/quotes/${identity}/catchment_works/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/v1/billing/quotes/${identity}/catchment_works/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Admin-only. A draft is not a CatchmentWork: it has no User and never reaches the DGA pipeline. `dga_code` is the real code only, never an invented one (Res. 1238). `flowmeter` and `level_sensor` in `rs485` are a 422 `/problems/quote-sensor-rs485-unsupported` until the datalogger reads RS485 sensors. `existing_catchment_work` is always sent (M-bill-21): null for a new work, or one of the client's works, whose name, category and DGA code the draft copies; such a draft sends none of the work data.
 * @summary Add a draft catchment work to a quote.
 */
 billingV1QuoteCatchmentWorksCreate<TData = QuoteCatchmentWorkResponseV1>(pathParams: BillingV1QuoteCatchmentWorksCreatePathParameters,
    quoteCatchmentWorkCreateRequestV1Request: QuoteCatchmentWorkCreateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuoteCatchmentWorksCreate<TData = QuoteCatchmentWorkResponseV1>(pathParams: BillingV1QuoteCatchmentWorksCreatePathParameters,
    quoteCatchmentWorkCreateRequestV1Request: QuoteCatchmentWorkCreateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuoteCatchmentWorksCreate<TData = QuoteCatchmentWorkResponseV1>(pathParams: BillingV1QuoteCatchmentWorksCreatePathParameters,
    quoteCatchmentWorkCreateRequestV1Request: QuoteCatchmentWorkCreateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuoteCatchmentWorksCreate<TData = QuoteCatchmentWorkResponseV1>(
    { identity }: BillingV1QuoteCatchmentWorksCreatePathParameters,
    quoteCatchmentWorkCreateRequestV1Request: QuoteCatchmentWorkCreateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/v1/billing/quotes/${identity}/catchment_works/`,
      quoteCatchmentWorkCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/v1/billing/quotes/${identity}/catchment_works/`,
      quoteCatchmentWorkCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/v1/billing/quotes/${identity}/catchment_works/`,
      quoteCatchmentWorkCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only.
 * @summary Get one draft catchment work of a quote.
 */
 billingV1QuoteCatchmentWorksRetrieve<TData = QuoteCatchmentWorkResponseV1>(pathParams: BillingV1QuoteCatchmentWorksRetrievePathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuoteCatchmentWorksRetrieve<TData = QuoteCatchmentWorkResponseV1>(pathParams: BillingV1QuoteCatchmentWorksRetrievePathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuoteCatchmentWorksRetrieve<TData = QuoteCatchmentWorkResponseV1>(pathParams: BillingV1QuoteCatchmentWorksRetrievePathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuoteCatchmentWorksRetrieve<TData = QuoteCatchmentWorkResponseV1>(
    { identity, workIdentity }: BillingV1QuoteCatchmentWorksRetrievePathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/quotes/${identity}/catchment_works/${workIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/quotes/${identity}/catchment_works/${workIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/v1/billing/quotes/${identity}/catchment_works/${workIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Only the keys sent change. `flowmeter` and `level_sensor` in `rs485` are a 422 `/problems/quote-sensor-rs485-unsupported` and nothing is applied. A draft of the client's own work (M-bill-21) takes only its `comment`: anything else is a 422 `/problems/quote-catchment-work-is-existing`.
 * @summary Partial-update a draft catchment work (preserve-on-omit).
 */
 billingV1QuoteCatchmentWorksPartialUpdate<TData = QuoteCatchmentWorkResponseV1>(pathParams: BillingV1QuoteCatchmentWorksPartialUpdatePathParameters,
    patchedQuoteCatchmentWorkUpdateRequestV1Request?: PatchedQuoteCatchmentWorkUpdateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuoteCatchmentWorksPartialUpdate<TData = QuoteCatchmentWorkResponseV1>(pathParams: BillingV1QuoteCatchmentWorksPartialUpdatePathParameters,
    patchedQuoteCatchmentWorkUpdateRequestV1Request?: PatchedQuoteCatchmentWorkUpdateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuoteCatchmentWorksPartialUpdate<TData = QuoteCatchmentWorkResponseV1>(pathParams: BillingV1QuoteCatchmentWorksPartialUpdatePathParameters,
    patchedQuoteCatchmentWorkUpdateRequestV1Request?: PatchedQuoteCatchmentWorkUpdateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuoteCatchmentWorksPartialUpdate<TData = QuoteCatchmentWorkResponseV1>(
    { identity, workIdentity }: BillingV1QuoteCatchmentWorksPartialUpdatePathParameters,
    patchedQuoteCatchmentWorkUpdateRequestV1Request?: PatchedQuoteCatchmentWorkUpdateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/v1/billing/quotes/${identity}/catchment_works/${workIdentity}/`,
      patchedQuoteCatchmentWorkUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/v1/billing/quotes/${identity}/catchment_works/${workIdentity}/`,
      patchedQuoteCatchmentWorkUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/v1/billing/quotes/${identity}/catchment_works/${workIdentity}/`,
      patchedQuoteCatchmentWorkUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. A work with lines is a 409: move its lines to another work or delete them first.
 * @summary Delete a draft catchment work without lines.
 */
 billingV1QuoteCatchmentWorksDestroy<TData = void>(pathParams: BillingV1QuoteCatchmentWorksDestroyPathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuoteCatchmentWorksDestroy<TData = void>(pathParams: BillingV1QuoteCatchmentWorksDestroyPathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuoteCatchmentWorksDestroy<TData = void>(pathParams: BillingV1QuoteCatchmentWorksDestroyPathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuoteCatchmentWorksDestroy<TData = void>(
    { identity, workIdentity }: BillingV1QuoteCatchmentWorksDestroyPathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/v1/billing/quotes/${identity}/catchment_works/${workIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/v1/billing/quotes/${identity}/catchment_works/${workIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/v1/billing/quotes/${identity}/catchment_works/${workIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

export type BillingV1QuoteCatchmentWorksListClientResult = NonNullable<CursorPaginatedQuoteCatchmentWorkResponseV1>
export type BillingV1QuoteCatchmentWorksCreateClientResult = NonNullable<QuoteCatchmentWorkResponseV1>
export type BillingV1QuoteCatchmentWorksRetrieveClientResult = NonNullable<QuoteCatchmentWorkResponseV1>
export type BillingV1QuoteCatchmentWorksPartialUpdateClientResult = NonNullable<QuoteCatchmentWorkResponseV1>
export type BillingV1QuoteCatchmentWorksDestroyClientResult = NonNullable<void>
